import type { TableOptions, Table } from '../../common/types/general';
import { Child } from '../../common/types/child';
import formatter from '../../common/helpers/formatter';
import sort from '../../common/helpers/sort';

const reactAppVersion = process.env.REACT_APP_VERSION;

const fhfTable: Table<Child>[] = [
  { headline: 'Name', type: 'text', sortable: 'name', value: (child) => child.name || '' },
  {
    headline: 'Geburtstag',
    type: 'text',
    sortable: 'date',
    value: (child) => formatter.formatGermanDate(child.birthday),
  },
  { headline: '', type: 'delete', value: () => '' },
];

const getTableOptions = (): TableOptions<Child> => {
  if (reactAppVersion === 'fhf') {
    return {
      table: fhfTable,
      sort: (itemA, itemB, sortBy) => {
        if (sortBy != null && sortBy.sortable === 'name') {
          return sort.sortByString(itemA.name, itemB.name, sortBy.order);
        }
        return sort.sortByDate(itemA.birthday, itemB.birthday, sortBy != null ? sortBy.order : 'DESC');
      },
      filter: (searchValue, item) => (item.name || '').toLowerCase().includes(searchValue.toLowerCase()),
    };
  }
  return { table: [], sort: () => 1, filter: () => true };
};
export default getTableOptions;
